import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
`;

export const PerformanceCharsTitleDownloadContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: inherit;

  div:first-child {
    margin-right: 10px;
  }

  &:hover,
  &:active {
    color: inherit;
  }
`;
